// Boss-spec table — pure data, no logic.
// Modeled on species.ts. Each BossId maps to a BossSpec that drives spawn,
// AI, damage, and (eventually) the chain shader.

import type { BiomeId } from './biomes'

export type BossId = 'chain'
export type BossArchetype = 'chain'

export interface BossSpec {
  id: BossId
  archetype: BossArchetype
  biome: BiomeId
  dnaGate: number            // DNA required to wake the boss (checked by chain-boss-ai, not spawn)
  depthGate: number          // depthFactor threshold that triggers dormant placement
  segmentCount: number       // initial chain length
  segmentRadius: number      // world-space radius per segment
  segmentHp: number          // HP per segment
  segmentDamage: number      // damage dealt to player per contact
  linkDistance: number       // world-space distance between segment centers
  phase2Threshold: number    // fraction of segments remaining when phase 2 begins (0..1)
  narratorCue: { wake: string; phase2: string; killed: string }
  chain?: {
    whipRange: number        // distance at which the head telegraphs a whip-snap
    whipWindup: number       // seconds of windup before the snap
    whipRecovery: number     // seconds of recovery after the snap
    coilRadius: number       // radius of the constrict ring around the player
    coilWindup: number       // seconds to form the coil
    coilHold: number         // seconds the ring is held before releasing
    headHueOffset: number    // 0..1, iridescence anchor at the head
    tailHueOffset: number    // 0..1, iridescence anchor at the tail
  }
}

export const BOSSES: Record<BossId, BossSpec> = {
  chain: {
    id: 'chain',
    archetype: 'chain',
    biome: 'deep',
    dnaGate: 50,
    depthGate: 0.4,
    segmentCount: 7,
    segmentRadius: 0.11,
    segmentHp: 2,
    segmentDamage: 2,
    linkDistance: 0.22,
    phase2Threshold: 0.5,
    narratorCue: { wake: 'boss_wake', phase2: 'boss_phase2', killed: 'boss_killed' },
    chain: {
      whipRange: 1.2,
      whipWindup: 0.5,
      whipRecovery: 0.8,
      coilRadius: 0.6,
      coilWindup: 1.0,
      coilHold: 2.0,
      headHueOffset: 0,
      tailHueOffset: 0.85,
    },
  },
}
